import React from 'react';
import './InputV2.scss';

type Props = {
  value: string;
  onChange: (val: string) => void;
  className?: string;
  styles?: React.CSSProperties;
  wrapperStyles?: React.CSSProperties;
  placeholder: string;
  title: string;
  required?: boolean;
  validationFailureMessage?: string;
  id: string;
};

export function InputV2(props: Props) {
  const [isTouched, setIsTouched] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!isTouched && props.value) {
      setIsTouched(true);
    }
  }, [props.value, isTouched]);
  return (
    <div className="inputv2-w" style={props.wrapperStyles}>
      <input
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        style={props.styles}
        className={`${props.className || ''} ${
          props.required ? 'required' : ''
        }`}
        id={props.id}
        placeholder=" "
      />
      <label
        htmlFor={props.id}
        className={props.required ? 'mandatory-field' : ''}
      >
        {props.value ? props.title : props.placeholder}
      </label>
      <div className="form-error">
        {isTouched && props.validationFailureMessage}
      </div>
    </div>
  );
}
